export default __webpack_public_path__ + "static/media/640_dummy2016-apotheke01-de.1bbec0ea.png";